import { SUN_PALETTES } from '../../shared/palette';
import {
  type Face,
  type Pose,
  body,
  crossEye,
  dot,
  eye,
  gladFace,
  shut,
  stroke,
} from '../face-kit';
import type { Ctx } from '../paint';
import { SLIP, slipped } from './faux-contact-moments';

const PLUG = [-30, -24, 60, 58, 16] as const;
const PRONGS = [-13.5, 13.5] as const;
const PRONG = { width: 9, top: -46, height: 26, round: 2 };
const EYE = { x: 12, y: -2, dot: 4.2, cross: 5 };
const MOUTH = { y: 18, from: -14, step: 11, dash: 6, width: 4 };
const SLIP_SHIFT = 3;
const SLIP_ALPHA = 0.55;
const MARK = 'rgb(255 255 255)';

export const PRONG_TIPS: readonly (readonly [number, number])[] = PRONGS.map((x) => [x, PRONG.top]);
export const FOOT_AT: readonly [number, number] = [0, PLUG[1] + PLUG[3]];

function marks(ctx: Ctx, shift: number, color: string, swapped: boolean): void {
  const [round, crossed] = swapped ? [EYE.x, -EYE.x] : [-EYE.x, EYE.x];
  dot(ctx, round + shift, EYE.y, EYE.dot, color);
  const cx = crossed + shift;
  stroke(ctx, color, 4, [cx - EYE.cross, EYE.y - EYE.cross], [cx + EYE.cross, EYE.y + EYE.cross]);
  stroke(ctx, color, 4, [cx + EYE.cross, EYE.y - EYE.cross], [cx - EYE.cross, EYE.y + EYE.cross]);
  for (let index = 0; index < 3; index += 1) {
    const x = MOUTH.from + index * MOUTH.step + shift;
    stroke(ctx, color, MOUTH.width, [x, MOUTH.y], [x + MOUTH.dash, MOUTH.y]);
  }
}

function fauxContact(ctx: Ctx, pose: Pose): void {
  for (const x of PRONGS) {
    body(ctx, () => {
      ctx.beginPath();
      ctx.roundRect(x - PRONG.width / 2, PRONG.top, PRONG.width, PRONG.height, PRONG.round);
    });
  }
  body(ctx, () => {
    ctx.beginPath();
    ctx.roundRect(...PLUG);
  });
  if (shut(pose)) {
    eye(ctx, pose, -EYE.x, EYE.y, 5);
    crossEye(ctx, EYE.x, EYE.y, 3.5);
    return;
  }
  const frame = Math.floor(pose.t * SLIP.frames);
  if (!slipped(frame)) {
    marks(ctx, 0, MARK, false);
    return;
  }
  ctx.save();
  ctx.globalAlpha = SLIP_ALPHA;
  marks(ctx, -SLIP_SHIFT, SUN_PALETTES.nuit.mage, true);
  marks(ctx, SLIP_SHIFT, SUN_PALETTES.nuit.turquoise, true);
  ctx.restore();
  marks(ctx, 0, MARK, true);
}

function fauxContactGlad(ctx: Ctx): void {
  gladFace(ctx, { eyeY: -2, mouthY: 10, mouthWidth: 13 });
}

export const FAUX_CONTACT_FACE: Face = {
  draw: fauxContact,
  glad: fauxContactGlad,
  frames: SLIP.frames,
  loopBeats: SLIP.loopBeats,
  boss: true,
};
